import React, { useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { UserProvider, useUser } from './context/UserContext';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { BottomNav } from './components/BottomNav';
import { DiscoverPage } from './pages/DiscoverPage';
import axios from 'axios';
import { ProductPage } from './pages/ProductPage';
import { HomePage } from './pages/HomePage';
import { CommunityPage } from './pages/ComminityPage';
import { DispensaryDetailPage } from './pages/DispensaryDetailsPage';
// import { DispensariesPage } from './pages/DispensaryPage';
import { GrowJournalDetailPage } from './pages/GrowJournalDetailsPage';
// import { GrowJournalsPage } from './pages/GrowJournalPage';
import { ProductsPage } from './pages/ProductsPage';
// import { ResearchPage } from './pages/ResearchPage';
import { SeshRoomsPage } from './pages/SeshRoomsPage';
import { ThreadsPage } from './pages/ThreadsPage';
import { StoriesPage } from './pages/StoriesPage';
import { THCLeaderboardPage } from './pages/THCLeaderboardPage';
import { useParams } from 'react-router-dom';
// import ZenGarden from './growroom/pages/ZenGarden';
import { StrainDetailPage } from './pages/StrainDetailPage';
import ResearchHub from './pages/ResearchHub';
import ProfilePage from './profile_component/ProfilePage';
import CannabisGrowRoom from './growroom/3dGrowRoom';
import ForgotPasswordPage from './auth/ForgotPassword';
import ResetPasswordPage from './auth/ResetPassword';
import LoginPage from './auth/Login';
import { VersionChecker } from './admin_component/VersioningChecker';
import BugReportButton from './arrangement/ReportIssue';
import './App.css';
import API_URL from './config/ApiUrl';
import { AdminDashboard } from './admin_component/AdminPage';
import { GlobalThemeStyles } from './arrangement/GLobalThemeStyles';
import { ThemeProvider } from './arrangement/ThemeContext';
axios.defaults.withCredentials = true;

// Component that handles heartbeat logic
function AppWithHeartbeat() {
  const { user } = useUser();
  const heartbeatRef = useRef(null);

  const startHeartbeat = () => {
    if (heartbeatRef.current) return; // Already running

    heartbeatRef.current = setInterval(() => {
      fetch(`${API_URL}/api/heartbeat`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        }
      }).catch(err => console.log('Heartbeat failed:', err));
    }, 30000); // 30 seconds
  };

  const stopHeartbeat = () => {
    if (heartbeatRef.current) {
      clearInterval(heartbeatRef.current);
      heartbeatRef.current = null;
    }
  };

  useEffect(() => {
    // Start heartbeat if user is logged in
    if (user) {
      startHeartbeat();
    } else {
      stopHeartbeat();
    }

    // Handle page visibility changes
    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopHeartbeat();
      } else if (user) {
        startHeartbeat();
      }
    };

    // Handle page unload
    const handleBeforeUnload = () => {
      navigator.sendBeacon('/api/logout', JSON.stringify({}));
      stopHeartbeat();
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    // Cleanup
    return () => {
      stopHeartbeat();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [user]);

  return (
    <>
    <ThemeProvider>
    <GlobalThemeStyles /><div style={{
      minHeight: '100vh',
      backgroundColor: '#f9fafb',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      {/* <VersionChecker />  */}
      <div style={{
        position: 'relative',
        display: 'flex',
        minHeight: '100vh',
        flexDirection: 'column'
      }}>
        <SiteHeader />

        <main style={{ flex: 1 }}>
          <div className="main-content">
            <Routes>
              {/* Home */}
              <Route path="/" element={<HomePage />} />

              {/* Products */}
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/products/:slug" element={<ProductPageWrapper />} />

              <Route path="/discover" element={<DiscoverPage />} />
              {/* <Route path="/ai-discover" element={<AiDiscoverPage />} /> */}

              {/* Strains */}
              <Route path="/strains/:slug" element={<StrainDetailPageWrapper />} />

              {/* Dispensaries */}
              {/* <Route path="/dispensaries" element={<DispensariesPage />} /> */}
              <Route path="/dispensaries/:slug" element={<DispensaryDetailPageWrapper />} />

              {/* Community */}
              <Route path="/community" element={<CommunityPage />} />
              {/* <Route path="/stories" element={<StoriesPage />} /> */}

              {/* Sesh Rooms */}
              <Route path="/sesh-rooms" element={<SeshRoomsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              {/* Grow Journals
    <Route path="/grows" element={<GrowJournalsPage />} /> */}
              <Route path="/grows/:journalId" element={<GrowJournalDetailsPageWrapper />} />

              {/* Research */}
              {/* <Route path="/research" element={<ResearchPage />} /> */}
              <Route path="/thc-leaderboard" element={<THCLeaderboardPage />} />

              {/* Profile */}
              <Route path="/profile/:username" element={<ProfilePageWrapper />} />
              <Route path="/grow-room" element={<CannabisGrowRoom />} />
              <Route path="/threads" element={<ThreadsPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/researchhub" element={<ResearchHub />} />
              <Route path="/g" element={<CannabisGrowRoom />} />
              <Route path="/adminpage" element={<AdminDashboard />} />

              {/* Catch all - 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <BugReportButton />
        </main>

        {/* <SiteFooter />
    <BottomNav /> */}
      </div>
    </div>
    </ThemeProvider></>
  );
}

function App() {
  return (
    <UserProvider>
      <Router>
        <AppWithHeartbeat />
      </Router>
    </UserProvider>
  );
}

// Wrapper components to extract URL parameters
function ProductPageWrapper() {
  const { slug } = useParams();
  return <ProductPage slug={slug} />;
}

function StrainDetailPageWrapper() {
  const { slug } = useParams();
  return <StrainDetailPage slug={slug} />;
}

function DispensaryDetailPageWrapper() {
  const { slug } = useParams();
  return <DispensaryDetailPage slug={slug} />;
}

function GrowJournalDetailsPageWrapper() {
  const { journalId } = useParams();
  return <GrowJournalDetailPage journalId={journalId} />;
}

function ProfilePageWrapper() {
  const { username } = useParams();
  return <ProfilePage username={username} />;
}

// 404 Component
function NotFound() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '32px'
    }}>
      <h1 style={{ fontSize: '48px', fontWeight: 'bold', margin: '0 0 16px 0' }}>404</h1>
      <p style={{ fontSize: '18px', color: '#6b7280', margin: '0 0 24px 0' }}>
        Oops! The page you're looking for doesn't exist.
      </p>
      <button 
        onClick={() => window.location.href = '/'}
        style={{
          padding: '12px 24px',
          backgroundColor: '#2563eb',
          color: 'white',
          borderRadius: '8px',
          border: 'none',
          cursor: 'pointer',
          fontSize: '16px'
        }}
      >
        Go Home
      </button>
    </div>
  );
}

export default App;